enum VoucherCancellationType {
  ENTIRE = 'ENTIRE',
  VOUCHER = 'VOUCHER'
}
export default VoucherCancellationType;
